import { render, staticRenderFns } from "./PMStructureTasksFormSettingsAndCreate.vue?vue&type=template&id=2ba10d43&scoped=true&"
import script from "./PMStructureTasksFormSettingsAndCreate.vue?vue&type=script&lang=ts&"
export * from "./PMStructureTasksFormSettingsAndCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PMStructureTasksFormSettingsAndCreate.vue?vue&type=style&index=0&id=2ba10d43&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba10d43",
  null
  
)

export default component.exports